import { RadioTile, TileGroup, Tooltip } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { additionOption } from '../../../constants/default';
import { QuesIDProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';

type Step6Props = {
  que3Value: string;
  que4Value: string;
  que5Value: string;
  que6Value: string;
  setQue6Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  useTranslation: TranslationFunction;
};

const Step6 = ({
  que3Value,
  que5Value,
  que4Value,
  que6Value,
  setQue6Value,
  setIsRequired,
  trackQuesID,
  setTrackQuesID,
  useTranslation,
}: Step6Props) => {
  const isSmall = useSmallBreakpoint('560px');
  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue6Value(value);
    if (que3Value === '' && que4Value === '' && que5Value === '') {
      setIsRequired(true);
    } else {
      setIsRequired(false);
    }

    setTrackQuesID({
      ...trackQuesID,
      Q6: (event.target as HTMLInputElement).id,
    });

    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: `question 6 - ${value} - selected`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  useEffect(() => {
    if (que6Value) {
      setIsRequired(false);
    }
  }, []);

  return (
    <div>
      <label className="page_sub_heading padding_8">
        {useTranslation('que6_text_desc')}
      </label>
      <TileGroup name="radio-group" valueSelected={que6Value}>
        <RadioTile
          className="tileMulti"
          id="Q6A1"
          value={additionOption.opt1}
          onClick={(e) => handleClick(additionOption.opt1, e)}
        >
          {useTranslation('que6_opt1')}
          <Tooltip
            className="maas360_widget__maas360-tooltip"
            onChange={() => {
              // For segment tracking
              segmentsTracking('CTA Clicked', {
                pageTitle: 'MaaS360 Plan Assessment',
                object: 'Mass360 page',
                resultValue: 'CTA clicked',
                CTA: `question 6 - opt1 Remote access - tooltip`,
                location: 'Assessment',
                action: '',
                field: '',
              });
            }}
            direction={isSmall ? 'bottom' : 'right'}
            tabIndex={0}
          >
            <span className="slide_text">
              {useTranslation('que6_opt1_tooltip')}
            </span>
          </Tooltip>
        </RadioTile>
        <RadioTile
          className="tileMulti"
          id="Q6A2"
          value={additionOption.opt2}
          onClick={(e) => handleClick(additionOption.opt2, e)}
        >
          {useTranslation('que6_opt2')}
        </RadioTile>
        <RadioTile
          className="tileMulti"
          id="Q6A3"
          value={additionOption.opt3}
          onClick={(e) => handleClick(additionOption.opt3, e)}
        >
          {useTranslation('que6_opt3')}
        </RadioTile>
      </TileGroup>
    </div>
  );
};

export default Step6;
